import { FC } from 'react'

import { Nav } from './Nav'
import { ContentContainer } from 'ui'
import { useUIGlobalsContext } from 'ui/lib/ui-globals/hooks'

export interface ISlideOutProducts {}

const SlideOutCategories: FC<ISlideOutProducts> = () => {
  const { menuMaxContentWidth } = useUIGlobalsContext()

  return (
    <ContentContainer
      className="slide-out-categories"
      minH="20vh"
      p="0"
      py={{
        base: 4,
        md: 0
      }}
      spacing="6"
      w="100%"
      maxW={menuMaxContentWidth}
    >
      <Nav />
    </ContentContainer>
  )
}

export default SlideOutCategories
